function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m504.503906 27.34375v398.144531c0 5.007813-4.0625 9.066407-9.070312 9.066407h-478.867188c-5.007812 0-9.070312-4.058594-9.070312-9.066407v-398.15625c0-10.953125 8.882812-19.835937 19.835937-19.835937h457.335938c10.949219 0 19.835937 8.886718 19.835937 19.847656zm0 0",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m504.503906 27.34375v70.933594h-497.003906v-70.933594c0-10.960938 8.882812-19.847656 19.835938-19.847656h457.332031c10.949219 0 19.835937 8.886718 19.835937 19.847656zm0 0",
  fill: "#e4eaf8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m504.5 82.410156h-497v-55.070312c0-10.957032 8.882812-19.839844 19.839844-19.839844h457.320312c10.957032 0 19.839844 8.882812 19.839844 19.839844zm0 0",
  fill: "#ffc850"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m411.148438 334.65625h-310.296876c-4.28125 0-7.75-3.46875-7.75-7.75v-32.132812c0-4.28125 3.46875-7.75 7.75-7.75h310.296876c4.277343 0 7.75 3.46875 7.75 7.75v32.132812c0 4.28125-3.46875 7.75-7.75 7.75zm0 0",
  fill: "#abffdb"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m484.660156 0h-457.320312c-15.074219 0-27.339844 12.265625-27.339844 27.339844v116.042968c0 4.140626 3.359375 7.5 7.5 7.5s7.5-3.359374 7.5-7.5v-116.042968c0-6.804688 5.535156-12.339844 12.339844-12.339844h457.320312c6.804688 0 12.339844 5.535156 12.339844 12.339844v84.042968c0 4.140626 3.355469 7.5 7.5 7.5 4.140625 0 7.5-3.359374 7.5-7.5v-84.042968c0-15.074219-12.265625-27.339844-27.339844-27.339844zm0 0",
  fill: "#474d54"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m504.5 134.5c-4.144531 0-7.5 3.359375-7.5 7.5v283.488281c0 .863281-.703125 1.566407-1.566406 1.566407h-53.121094c-4.144531 0-7.5 3.359374-7.5 7.5 0 4.144531 3.355469 7.5 7.5 7.5h53.121094c9.136718 0 16.566406-7.429688 16.566406-16.566407v-283.488281c0-4.140625-3.359375-7.5-7.5-7.5zm0 0",
  fill: "#474d54"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m411.691406 427.054688h-395.125c-.863281 0-1.566406-.703126-1.566406-1.566407v-251.488281c0-4.140625-3.359375-7.5-7.5-7.5s-7.5 3.359375-7.5 7.5v251.488281c0 9.136719 7.433594 16.566407 16.566406 16.566407h395.125c4.144532 0 7.5-3.355469 7.5-7.5 0-4.140626-3.355468-7.5-7.5-7.5zm0 0",
  fill: "#474d54"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m341.691406 38.839844h-267.53125c-4.140625 0-7.5 3.359375-7.5 7.5 0 4.144531 3.359375 7.5 7.5 7.5h267.53125c4.144532 0 7.503906-3.355469 7.503906-7.5 0-4.140625-3.359374-7.5-7.503906-7.5zm0 0",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m377.964844 36.804688c-4.144532 0-7.5 3.355468-7.5 7.5v1.300781c0 4.144531 3.355468 7.5 7.5 7.5 4.140625 0 7.5-3.355469 7.5-7.5v-1.300781c0-4.144532-3.359375-7.5-7.5-7.5zm0 0",
  fill: "#ff8031"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m407.902344 36.804688c-4.144532 0-7.5 3.355468-7.5 7.5v1.300781c0 4.144531 3.355468 7.5 7.5 7.5 4.144531 0 7.5-3.355469 7.5-7.5v-1.300781c0-4.144532-3.355469-7.5-7.5-7.5zm0 0",
  fill: "#ff8031"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m437.839844 36.804688c-4.144532 0-7.5 3.355468-7.5 7.5v1.300781c0 4.144531 3.355468 7.5 7.5 7.5 4.144531 0 7.5-3.355469 7.5-7.5v-1.300781c0-4.144532-3.355469-7.5-7.5-7.5zm0 0",
  fill: "#ff8031"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  fill: "#abb0b7"
}, /*#__PURE__*/React.createElement("path", {
  d: "m132.398438 160.046875c-3.777344-1.703125-8.21875-.019531-9.921876 3.757813l-23.382812 51.882812c-1.046875 2.324219-.84375 5.015625.539062 7.152344 1.378907 2.140625 3.75 3.429687 6.296876 3.429687h29.011718v20.398438c0 4.140625 3.359375 7.5 7.503906 7.5 4.140626 0 7.5-3.359375 7.5-7.5v-27.898438c0-4.140625-3.359374-7.5-7.5-7.5h-24.90625l18.613282-41.304687c1.703125-3.773438.023437-8.214844-3.753906-9.917969zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m252.261719 160.046875c-3.773438-1.703125-8.214844-.019531-9.917969 3.757813l-23.386719 51.882812c-1.042969 2.324219-.84375 5.015625.539063 7.152344 1.382812 2.140625 3.753906 3.429687 6.300781 3.429687h29.011719v20.398438c0 4.140625 3.359375 7.5 7.5 7.5 4.144531 0 7.5-3.359375 7.5-7.5v-27.898438c0-4.140625-3.355469-7.5-7.5-7.5h-24.90625l18.613281-41.304687c1.703125-3.773438.023437-8.214844-3.753906-9.917969zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m165.855469 159.382812c-4.144531 0-7.5 3.359376-7.5 7.5v79.785157c0 4.140625 3.355469 7.5 7.5 7.5h38.257812c4.144531 0 7.5-3.359375 7.5-7.5v-79.785157c0-4.140624-3.355469-7.5-7.5-7.5-4.140625 0-7.5 3.359376-7.5 7.5v72.285157h-23.257812v-72.285157c0-4.140624-3.359375-7.5-7.5-7.5zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m305.925781 195.558594h25.675781c4.144532 0 7.5-3.359375 7.5-7.5 0-4.144532-3.355468-7.5-7.5-7.5h-25.675781c-4.144531 0-7.5 3.355468-7.5 7.5 0 4.140625 3.359375 7.5 7.5 7.5zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m305.925781 231.398438h84.089844c4.144531 0 7.5-3.359376 7.5-7.5 0-4.140626-3.355469-7.5-7.5-7.5h-84.089844c-4.144531 0-7.5 3.359374-7.5 7.5 0 4.140624 3.359375 7.5 7.5 7.5zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m305.925781 254.167969h84.089844c4.144531 0 7.5-3.359375 7.5-7.5 0-4.144531-3.355469-7.5-7.5-7.5h-84.089844c-4.144531 0-7.5 3.355469-7.5 7.5 0 4.140625 3.359375 7.5 7.5 7.5zm0 0"
}));

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -35 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.ff2a4534.svg";
export { ForwardRef as ReactComponent };